import React from "react";
import TextField from "@material-ui/core/TextField";

const NoCursorTextField = React.forwardRef(function NoCursorTextField(
    props,
    ref
) {
    const { disabled, InputProps, inputProps, ...rest } = props;

    return (
        <TextField
            {...rest}
            ref={ref}
            InputProps={{
                ...InputProps,
                readOnly: true,
                style: {
                    cursor: disabled ? "not-allowed" : "pointer"
                }
            }}
            inputProps={{
                ...inputProps,
                readOnly: true,
                style: {
                    caretColor: "transparent", // ⛔ hides text cursor
                    cursor: disabled ? "not-allowed" : "pointer"
                }
            }}
            onKeyDown={(e) => e.preventDefault()}   // block typing/backspace/delete
            onPaste={(e) => e.preventDefault()}
            onCut={(e) => e.preventDefault()}
            onDrop={(e) => e.preventDefault()}
        />
    );
});

export default NoCursorTextField;
